import {
  cmxTypeguards,
  codeBenchActions,
  commonEnums,
  shouldAutoAdvanceWorklistAfterSubmit
} from '@codametrix/ui-common';
import {
  getPrevOrNextCase,
  launchWorkitemInAmplify
} from '../../actions/cases.action';
import { Middleware } from 'redux';
import { MiddlewareProcessor, middleWareWrapper } from './middleware-utils';

const { loadNextOrPreviousCase, loadWorkitemInAmplify } = codeBenchActions;

const serviceDeskProcessor: MiddlewareProcessor = (api, next, action) => {
  if (
    cmxTypeguards.isReduxAction(action) &&
    action.type === loadNextOrPreviousCase.type &&
    action.payload
  ) {
    const status = action.payload.status?.toUpperCase();
    const cursorAPIPayload = action.payload?.cursorAPIPayload;
    if (
      status === commonEnums.FeedbackMeta.SUCCESS &&
      shouldAutoAdvanceWorklistAfterSubmit(cursorAPIPayload)
    ) {
      api.dispatch(getPrevOrNextCase(cursorAPIPayload) as any);
    }
  }

  if (action.type === loadWorkitemInAmplify.type) {
    const launchConfig = action.payload;
    api.dispatch(launchWorkitemInAmplify(launchConfig) as any);
  }
  return next(action);
};
export const serviceDeskMiddleware: Middleware = middleWareWrapper(
  serviceDeskProcessor
);
